import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { avoidWorks } from "@/mocks/site";

const grades = ["全部", "重度避雷", "中度避雷"];

export default function Avoid() {
  const [active, setActive] = useState("全部");
  const filtered = useMemo(
    () => (active === "全部" ? avoidWorks : avoidWorks.filter((w) => w.grade === active)),
    [active],
  );

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="mx-auto max-w-7xl px-4 md:px-6 pt-24 md:pt-32 pb-16">
        <nav aria-label="面包屑" className="text-sm text-foreground-500">
          <ol className="flex flex-wrap items-center gap-1">
            <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
            <li><i className="ri-arrow-right-s-line" aria-hidden="true"></i></li>
            <li aria-current="page" className="text-foreground-800">避雷区</li>
          </ol>
        </nav>

        <header className="mt-6 max-w-3xl">
          <p className="font-label text-sm text-primary-600">AVOID LIST</p>
          <h1 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-5xl">避雷区</h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            机翻、删页、嵌字粗糙的版本都在这。重度避雷指机翻严重、删页明显、译名混乱到影响理解；
            中度避雷指润色欠佳、嵌字粗糙但尚可读。别让烂翻译烂嵌字浪费你的时间。
          </p>
        </header>

        <div className="mt-8 flex flex-wrap items-center gap-2">
          {grades.map((g) => (
            <button
              key={g}
              type="button"
              onClick={() => setActive(g)}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                active === g
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {g}
            </button>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-6">
          {filtered.map((w) => (
            <article
              key={w.id}
              className="grid grid-cols-1 gap-5 overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-200 p-4 transition-shadow hover:shadow-lift sm:grid-cols-[180px_1fr] md:gap-6 md:p-6"
            >
              <div className="h-56 w-full overflow-hidden rounded-lg sm:h-full sm:min-h-[220px]">
                <img
                  src={w.image}
                  alt={`${w.title} 避雷封面`}
                  title={`${w.title} ${w.grade}`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <h2 className="font-heading text-xl font-bold text-foreground-950">{w.title}</h2>
                  <span
                    className={`rounded-full px-3 py-1 text-xs font-medium ${
                      w.grade === "重度避雷"
                        ? "bg-primary-100 text-primary-700"
                        : "bg-accent-100 text-accent-800"
                    }`}
                  >
                    {w.grade}
                  </span>
                </div>
                <p className="mt-1 text-sm text-foreground-500">{w.version}</p>
                <p className="mt-3 rounded-lg bg-background-100 px-4 py-3 text-sm leading-relaxed text-foreground-800">
                  <span className="font-medium text-primary-700">红线预警：</span>{w.redline}
                </p>
                <ul className="mt-4 flex flex-col gap-2">
                  {w.reasons.map((r, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-close-circle-line mt-0.5 shrink-0 text-primary-500" aria-hidden="true"></i>
                      <span>{r}</span>
                    </li>
                  ))}
                </ul>
                <p className="mt-4 text-xs text-foreground-500">
                  涉及章节：<span className="text-foreground-700">{w.scene}</span>
                </p>
              </div>
            </article>
          ))}
        </div>

        {/* 引导 */}
        <div className="mt-12 flex flex-col items-center justify-between gap-4 rounded-xl bg-background-100 px-6 py-8 sm:flex-row">
          <div>
            <h2 className="font-heading text-lg font-bold text-foreground-950">踩雷之后，去哪找舒服的版本？</h2>
            <p className="mt-1 text-sm text-foreground-600">去神翻译合集，逐话对比精选的润色佳作都在那。</p>
          </div>
          <Link
            to="/collections"
            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            去看神翻译合集
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}